import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5380_98371)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 8.99473 2.1941 11.477 5.0625 11.9271V7.73438H3.53906V6H5.0625V4.67813C5.0625 3.17438 5.95828 2.34375 7.32879 2.34375C7.98504 2.34375 8.67188 2.46094 8.67188 2.46094V3.9375H7.91531C7.17 3.9375 6.9375 4.40004 6.9375 4.875V6H8.60156L8.33555 7.73438H6.9375V11.9271C9.8059 11.477 12 8.99473 12 6Z",
			fill: "#1877F2"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.33555 7.73438L8.60156 6H6.9375V4.875C6.9375 4.40051 7.17 3.9375 7.91531 3.9375H8.67188V2.46094C8.67188 2.46094 7.98527 2.34375 7.32879 2.34375C5.95828 2.34375 5.0625 3.17438 5.0625 4.67813V6H3.53906V7.73438H5.0625V11.9271C5.68372 12.0243 6.31628 12.0243 6.9375 11.9271V7.73438H8.33555Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5380_98371",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgFacebookIcon;
